'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ClienteTitle from './ClienteTitle.jsx';
import Footer from './Footer.jsx';
import RadioButton from './RadioButton.jsx';
import { GenericErrorScreen, GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import MarcaBreadcrumb from './MarcaBreadcrumb.jsx';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';



class NuevaSolicitudAdministradora extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumb: []
        }
        this.breadcrumbGenerator = this.breadcrumbGenerator.bind(this)
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
        this.breadcrumbGenerator(this.props.tarjetas.administradora.Id,this.props.tarjetas.clienteResultadoBusqueda);
        (this.props.tarjetas.administradora && this.props.tarjetas.administradora.Id == 2) && this.props.selectRadioButton(2, this.props.tarjetas.administradora.Descripcion, this.props.tarjetas.administradora.Abreviatura);
    }

    actionFormosa() {
        this.props.actionFormosa();
    }

    render() {

        if (this.props.data.base.redirectToTipoEmpresa == true){
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudAdministradora", "ROUTE_TO_TIPO_EMPRESA")} push />
        }
        
        if (this.props.data.base.redirectToVistaCliente == true){
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudAdministradora", "ROUTE_TO_VISTA_CLIENTE")} push />
        }
        
        let permisos = this.props.data.base.permisos;
        
        if (permisos) {
            if (permisos.components.Pantalla.Active == true) {
                
                return (
                    <div className="container">
                        <div className="row">
                            <div classname="col-md-12">
                                <ClienteTitle
                                    cliente={this.props.tarjetas.clienteResultadoBusqueda}
                                    empresas={null}
                                    novedadesempresas={null}
                                    esmodificacion={false}
                                    />
                            </div>
                            <div className="col-md-12">
                                <MarcaBreadcrumb classname="breadcrumb"
                                    currentscreen={null}
                                    menu={this.state.breadcrumb}
                                    product={null}
                                    module={null} />
                                {GenericAlert}
                            </div>
                        </div>
                        
                        
                        <div className="row">
                            <div className="col-md-12">                  
                                <RadioButton
                                    data={this.props.data}
                                    administradoraSeleccionada={this.props.data.base.administradoraSeleccionadaId}
                                    tarjetas={this.props.data.base.administradora}
                                    selectRadioButton={this.props.selectRadioButton} />
                            </div>
                            <div classname="col-md-12">
                                <Footer data={this.props.data}
                                    tarjetas={this.props.tarjetas}
                                    permisos={permisos}
                                    showError={this.props.showError}
                                    routeTipoEmpresa={this.props.routeTipoEmpresa}
                                    routeToCancel={this.props.routeToCancel}
                                    routeToVistaCliente={this.props.routeToVistaCliente}/>
                            </div>
                        </div>
                    </div>
                );
            } else {
                if (permisos.components.Pantalla.Active == false) {
                    let values = {
                        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                        linkMessage: "Volver a mi pagina de inicio"
                    };
                    return <GenericErrorScreen data={values} />;
                }
            }
        } else {
            return null;
        }
    }

    breadcrumbGenerator(idAdm,cliente) {
        let nuevaSolicitudMap = [];
        if (cliente.esPersonaFisica) {
            nuevaSolicitudMap.push({ descripcion: "Marca", ruta: "", activo: true, normal: false });
            nuevaSolicitudMap.push({ descripcion: "Tipo de Cuenta", ruta: "", activo: false, normal: true });
            nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true });
        } else if (!cliente.esPersonaFisica) {
            if (idAdm == 1) {
                nuevaSolicitudMap.push({ descripcion: "Marca", ruta: "", activo: true, normal: false });
                nuevaSolicitudMap.push({ descripcion: "Tipo de Empresa", ruta: "", activo: false, normal: true });
                nuevaSolicitudMap.push({ descripcion: "Empresa", ruta: "", activo: false, normal: true });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true });
                nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true });
            } else if (idAdm == 2) {
                nuevaSolicitudMap.push({ descripcion: "Marca", ruta: "", activo: true, normal: false });
                nuevaSolicitudMap.push({ descripcion: "Tipo de Cuenta", ruta: "", activo: false, normal: true });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true });
                nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true });
            }
        }
        this.setState({ breadcrumb: nuevaSolicitudMap })
    }

}

export default NuevaSolicitudAdministradora;
